import React from 'react';
import IconContainer from './icon_container';

export default function(props) {
  return (
    <IconContainer viewBox="0 0 51 51" {...props} className="circleCheckIcon">
      <g strokeWidth="2" fill="none">
        <circle cx="25" cy="25" r="25" stroke="#009B00" strokeWidth="2" />
        <path
          d="M14 26.226L21.83 33 37 18"
          stroke="#0E790E"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </IconContainer>
  );
}



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/lib/icons/success_icon.jsx